const React = require('react');
const ReactIntl = require('react-intl');
const defaultMessages = require('../../i18n/messages/default');
const injectIntl = ReactIntl.injectIntl;
const { Footer, FooterSelect, FooterLink  } = require('metro-ui-components');
const createReactClass = require('create-react-class');
const { pickBy } = require('lodash');
const LoginActions = require('../../actions/LoginActions');
const TranslationsActions = require('../../actions/TranslationsActions');
const LoginStore = require('../../stores/LoginStore');

const Utils = require('../../utils/Utils');
const UrlUtils = require('../../utils/urlUtils');
const LocaleUtils = require('../../utils/localeUtils')
const oAuthConstants = require('../../Auth/oAuthConstants');
const Constants = require('../../constants/AppConstants');

var FooterConponent = createReactClass({

    displayName: 'Footer',

    getInitialState() {
        return {
            localeId: this.props.localeId,
            localeData: Utils.mapLocaleData(this.props.supportedLocales || [this.props.localeId]),
        };
    },

    componentDidMount: function () {
        const redirectParams = this._getRouteParams();

        LoginStore.addChangeListener(this._onFooterConfigChange);                
        LoginActions.getWebPageConfigurations(
            { ...this.props, ...redirectParams },
            redirectParams.localeId || this.props.localeId
        );
    },

    _getRouteParams: function () {
        const clientId = UrlUtils.fetchClientIdInfo() || oAuthConstants.clientId;
        const redirectUri = UrlUtils.fetchRedirectURLInfo();
        const finalClient = UrlUtils.getParameterByName('slp_final_client_id', decodeURI(redirectUri));
        const finalRealm = UrlUtils.getParameterByName('slp_final_realm_id', decodeURI(redirectUri));
        const uri = window.location.href;
        let redirectParams = {};

        if (redirectUri && (uri.includes(Constants.Links.LINK_ACCOUNT) || uri.includes(Constants.Links.CONSENT))) {
            redirectParams = pickBy({
                clientId: finalClient || UrlUtils.getParameterByName('client_id', decodeURI(redirectUri)),
                realmId: finalRealm || UrlUtils.getParameterByName('realm_id', decodeURI(redirectUri)),
                countryCode: UrlUtils.getParameterByName('country_code', decodeURI(redirectUri)),
                localeId: UrlUtils.getParameterByName('locale_id', redirectUri),
            }, v => v !== null && v !== undefined);
        }

        return { clientId, ...redirectParams };
    },

    changeCopyrightValue: function () {
        let appState = LoginStore.getState();
        const currentYear = new Date().getFullYear();

        if(!appState.translations.copyrights){
            let defaultCopyright = this.props.intl.formatMessage(defaultMessages['copyrights']);
            return defaultCopyright
        }
        
        let copyrightValues = appState.translations.copyrights.split(" ");
        let copyrightTXT= "";

        if(parseInt(copyrightValues[0])){
            copyrightTXT = copyrightTXT.concat(currentYear, " ", copyrightValues.slice(1).join(" ")) 
            return copyrightTXT;
        }

        if(parseInt(copyrightValues[copyrightValues.length-1])){
            copyrightTXT = copyrightTXT.concat(copyrightValues.slice(0,-1).join(" "), " ", currentYear) 
            return copyrightTXT;
        }
    },

    _handleLocaleChange: function (locale, evt) {

        const selectedLocale = locale || evt.target.value;

        if (this.state.localeId === selectedLocale) {
            evt.preventDefault();
        } else {
            const newUrl = UrlUtils.setQueryParameter("locale_id", selectedLocale, window.location.href)
            const redirectParams = this._getRouteParams();
            const enhancedProps = { ...this.props, ...redirectParams }
            window.history.pushState("", "", newUrl);
            if (selectedLocale !== "xx-XX")
                LoginActions.getWebPageConfigurations(enhancedProps, selectedLocale);
            TranslationsActions.getTranslations(this.props.countryCode, selectedLocale);
            this.setState({ localeId: selectedLocale });
            Utils.setGADatalayer(this.props.countryCode, selectedLocale, this.props.userType, this.props.realmId, enhancedProps.clientId, this.props.redirectUrl);
            this.props.onLocalChange(selectedLocale);
            Utils.addHtlmLangAttribute(selectedLocale.substring(0,2));
            evt.preventDefault();
            
        }
    },

    _onFooterConfigChange: function () {
        let appState = LoginStore.getState();        
        this.setState({
            footerItems: appState.footerItems,            
        });
    },

    _renderLocales: function () {
        return (
            <div>
                <span className="hidden-lg hidden-md">
                    {this._renderAllAvailableLocalesMobile()}
                </span>
                <span className="hidden-sm hidden-xs">
                    {this._renderAllAvailableLocales()}
                </span>
            </div>
        );
    },

    _renderAllAvailableLocales: function () {
        const self = this;
        let localeId = this.state.localeId;

        if (this.state.localeData && this.state.localeData.length === 1) return ;
        return this.state.localeData
            .map(function (option, i) {
                return <FooterLink key={'c' + i} href="#" active={localeId === option['locale']} onClick={self._handleLocaleChange.bind(null, option['locale'])}>
                    {option['displayName']}
                </FooterLink>
            });
    },

    _renderAllAvailableLocalesMobile: function () {
        const self = this;
        let localeId = this.state.localeId;
        if (this.state.localeData && this.state.localeData.length === 1) return ;
        return <FooterSelect value={localeId} onChange={self._handleLocaleChange.bind(null, this.value)} >
            {this.state.localeData
                .map(function (option, i) {
                    var dropdownOption;
                    dropdownOption = <option value={option['locale']} key={'b' + i}>
                        {option['displayName']}
                    </option>
                    return dropdownOption;
                })};
            </FooterSelect>
    },

    _renderCopyright: function (column) { 
        return (
            <span id="copyright">
                &copy;{'\u00A0'}
                {
                    this.changeCopyrightValue()
                }
            </span>
        )
    },


    _renderFooterLinks: function (footerItems) {
        var indents = [];
        //Always add Copyright in footer item
        indents.push(this._renderCopyright());

        footerItems.forEach(function (item, i) {
            item.value = UrlUtils.varyByCountry(item.value, this.props.countryCode);

            indents.push(<FooterLink href={item.value} key={'a' + i} target="_blank">
                {LocaleUtils.formatMessage(
                    this.props.intl,
                    defaultMessages,
                    (item.key || item.displayText),
                    item.displayText
                )}
            </FooterLink>)
        }, this);
        return indents;
    },

    render: function () {

        if (!this.state.footerItems || !this.state.footerItems.length) {
            return (<div>
                <Footer>
                    <span>
                        {this._renderCopyright()}
                    </span>
                    {this._renderLocales()}
                </Footer>
            </div>)
        }

        var footerItems = this.state.footerItems;
        return (
            <div>
                <Footer>
                    <span>
                        {this._renderFooterLinks(footerItems)}
                    </span>
                    {this._renderLocales()}

                </Footer>
            </div>
        );
    }
});

module.exports = injectIntl(FooterConponent);
